export type InstallmentCouponPreviewScenario =
  | "value"
  | "trial_then_value"
  | "upfront_then_value"
  | "trial_then_upfront_then_value"
  | "upfront_then_trial_then_value";

interface InstallmentCouponPaymentSelectionInput {
  installmentAmount: number;
  previewScenario: InstallmentCouponPreviewScenario;
  upfrontPaymentAmount: number;
}

export const selectInstallmentCouponPaymentAmount = ({
  previewScenario,
  upfrontPaymentAmount,
  installmentAmount,
}: InstallmentCouponPaymentSelectionInput): number => {
  const isUpfrontScenario =
    previewScenario === "upfront_then_value" ||
    previewScenario === "trial_then_upfront_then_value" ||
    previewScenario === "upfront_then_trial_then_value";

  return isUpfrontScenario && upfrontPaymentAmount > 0
    ? upfrontPaymentAmount
    : installmentAmount;
};
